import type { ActivationLifecycle } from '@/infra/activation'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import { InfiniteScrollProvider } from '@/infra/InfiniteScrollProvider'
import type { AlertRetryWrapperFactory } from '@/features/shell'
import { type WorkspacePostingOpportunity } from './WorkspacePostingOpportunity'
import { type ListWorkspacePostingOpportunitiesFn } from './WorkspacePostingOpportunityStore'

/**
 * Implements workspace posting searching.
 */
export class WorkspacePostingOpportunitiesSearchViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  readonly scroller = new InfiniteScrollProvider<WorkspacePostingOpportunity>({
    limit: 20,
    fetchItems: ({ paging, signal }) => {
      const withRetry = this._createAlertRetryWrapper(
        'Unable to load outsourcing posts',
        signal,
      )

      return withRetry(() => this._opportunityFetcher(paging, signal))
    },
  })

  constructor(
    private readonly _opportunityFetcher: ListWorkspacePostingOpportunitiesFn,
    private readonly _createAlertRetryWrapper: AlertRetryWrapperFactory,
  ) {}

  /** @inheritDoc */
  activate() {
    this._lifecycle.activate()
    // The retry alert has reported a failure.
    this.scroller
      .fetch({ signal: this._lifecycle.signal })
      .catch(() => undefined)
  }

  /** @inheritDoc */
  deactivate() {
    this._lifecycle.deactivate()
  }
}
